import React from 'react';
import { cn } from '@/lib/utils';

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * PageContainer provides consistent responsive padding across all pages.
 * 
 * Responsive breakpoints:
 * - Mobile: px-4 py-6 (16px horizontal, 24px vertical)
 * - Small: px-6 (24px horizontal)  
 * - Large: px-8 py-8 (32px horizontal and vertical)
 * 
 * This is now the ONLY source of horizontal padding when used with BaseLayout.
 * BaseLayout no longer adds horizontal padding to prevent double-padding.
 */
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div className={cn('px-4 py-6 sm:px-6 lg:px-8 lg:py-8', className)}>
      {children}
    </div>
  );
}
